import { makeActionCreator } from '../../../../utilities'
import { RescueConstants } from './rescue.constants'

export const setTypes = makeActionCreator(RescueConstants.SET_TYPES, 'rescueTypes')
export const setHydraulics = makeActionCreator(RescueConstants.SET_HYDRAULICS, 'hydraulics')
export const setTools = makeActionCreator(RescueConstants.SET_TOOLS, 'tools')
export const setRehab = makeActionCreator(RescueConstants.SET_REHAB, 'rehab')
export const setActivations = makeActionCreator(RescueConstants.SET_ACTIVATIONS, 'activations')
export const setSize = makeActionCreator(RescueConstants.SET_SIZE, 'size')
export const saveRescue = makeActionCreator(RescueConstants.SAVE_RESCUE, 'data')
export const resetState = makeActionCreator(RescueConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(RescueConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(RescueConstants.SET_STATE, 'rescueState')
export const setDateTime = makeActionCreator(RescueConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(RescueConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectRescueProcedure = makeActionCreator(RescueConstants.ON_SELECT_RESCUE)
export const setUpdateInputRows = makeActionCreator(RescueConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(RescueConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(RescueConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(RescueConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
